import { Box, Button, CircularProgress, Container, List, Stack, Typography } from "@mui/material";
import React from "react";
import { TypeFrigorficos, TypePlantas } from "./interace/frigorifico.interface";
import { useLocation, useNavigate } from "react-router-dom";
//import { frigorificos } from '../../api/frigorificos';
import { useAppSelector } from "../../redux/hooks";
import { useGetFriosByUserQuery } from "../../api/frioApi";
import { handleMutationError } from "../../api/handleMutationError";
import { FrigorificoComponent } from "../../components";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

export const FrigorificoPage: React.FC = () => {

  const navigate = useNavigate();

  const {userData } = useAppSelector((state) => state.authReducer)

  const plantaData = useLocation();


  //Si los parametros son null o no existem vuelve a home
  React.useEffect(() => {
    if (!plantaData.state) {
      navigate('/');
    }
  }, [plantaData, navigate]);
  
  
  const planta: TypePlantas | undefined = plantaData?.state;

  const {
    data,
    isLoading,
    isError, 
    error
  } = useGetFriosByUserQuery({userId: userData?.id ?? "", plantaId: planta?.id ?? ""}, {
      skip: !planta?.id || !userData?.id,
   // refetchOnMountOrArgChange: true, //revalida la informacion cuando se monta el componente, pero la revalidacion la hace en background 
    //refetchOnMountOrArgChange: 10, //revalida la informacion cuando se monta el componente pero a los 10 segundos de la ultima vez que hizo un get satisfactorio, pero la revalidacion la hace en background 
  //  refetchOnFocus: true, //revalida la informacion cuando se pone el focus
  //  refetchOnReconnect: true, //revalida la informacion cuando se vuelve a conectar el servidor
  });

    // 🔹 Si no hay datos aún, no renderiza nada
  if (!plantaData.state) {
    return <></>;
  }

  return (
    <Container 
      maxWidth={false} 
      sx={{
        px: 2, // padding horizontal: 2*8px = 16px
      }}
    > 
    {/*<Container maxWidth="xl">*/}
        <Stack sx={{my: 2}} spacing={2} direction="row">
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/")}
            startIcon={<NavigateBeforeIcon />} 
          >
            PLANTAS
          </Button>
        </Stack>
        {/* Título de la Lista */}
        <Typography
          textAlign="center"
          sx={{
            marginTop: 2,
            marginBottom: 2,
            fontSize: {
              xs: "1.2rem",  // móviles
              sm: "1.5rem",  // tablets
              md: "1.8rem",  // notebooks
              lg: "2rem",    // monitores grandes
              xl: "2.2rem",  // pantallas muy grandes
            },
            fontWeight: "bold",
          }}
        >      
          {"Planta: " + planta?.name_front}
        </Typography>
        {isError && <p>Falla Conexion con el servidor: {error? handleMutationError(error) : 'Falla no reconocida'}</p>}
        {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) :
      (
        <List>
          {(data && data.data.frigorifico?.length !== 0) ? (
              data.data.frigorifico!.map((frigorifico: TypeFrigorficos) => (
                  <FrigorificoComponent  key={frigorifico.id} propsPlanta={planta!} propsFrigorifico={frigorifico} />
              )
            )): 
              ("No hay frigorificos para mostrar")
          }
        </List>
      )}
    </Container>
  )
}